import { ReactNode } from 'react'
import { Breadcrumb } from '~/features/shared/breadcrumbList/components/Breadcrumb'
import { BreadcrumbData } from '~/features/shared/breadcrumbList/types'

type Props = {
  breadcrumbList?: BreadcrumbData[]
  children?: ReactNode
}

export const HeadlineForPc: React.FC<Props> = ({
  children,
  breadcrumbList,
}) => {
  return (
    <div className="bg-white pb-[14px] pt-[15px]">
      <div className="mx-auto flex w-[990px]">
        <div className="pt-[7px]">
          <Breadcrumb list={breadcrumbList} />
        </div>
        <div className="ml-auto">{children}</div>
      </div>
    </div>
  )
}
